<script>
import { BCardTitle } from "bootstrap-vue";

export default {
  extends: BCardTitle
};
</script>